import { memo } from 'react';
import { Icon } from '@ui/components';
import { GroupInfoSpinner } from './spinner';

export const GroupInfoLoadingState = memo(() => (
  <div className="flex-1 flex flex-col justify-center items-center py-16 bg-gradient-to-b from-white via-orange-50/30 to-white">
    <div className="relative mb-6">
      <div className="absolute inset-0 bg-orange-500 rounded-full blur-2xl opacity-20 animate-pulse" />
      <div className="relative">
        <GroupInfoSpinner size="lg" className="border-gray-200 border-t-orange-500" />
        <div className="absolute inset-0 flex items-center justify-center">
          <Icon type="people" className="text-orange-500 w-5 h-5" />
        </div>
      </div>
    </div>
    <div className="text-base font-semibold text-gray-900 mb-1">Loading members...</div>
    <div className="text-sm text-gray-500">{`This won't take long`}</div>
  </div>
));

GroupInfoLoadingState.displayName = 'GroupInfoLoadingState';
